import React from "react";
import styles from "./createAlbumSuccess.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";

const CreateAlbumSuccess = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { title, uploadDate, expiryDate } = state;
  console.log(title, uploadDate, expiryDate);
  return (
    <div>
      <Header />
      <div className={styles.CreateAlbumSuccessMain}>
        <h5 className={styles.createAlbumSuccessMainHeader}>
          アップロード完了
        </h5>
        <div
          className={`${styles.CreateAlbumSuccessDiv} d-flex flex-column justify-content-around py-4`}
        >
          <span>{title}</span>
          <div className="d-flex justify-content-center">
            <span>アップロード日時</span>
            <span className="ml-3">{uploadDate}</span>
          </div>
          <div className="d-flex justify-content-center">
            <span>保管期限</span>
            <span className="ml-3">{expiryDate}</span>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            className={`${styles.CreateAlbumSuccessBtn} btn`}
            onClick={() => {
              navigate("/design-box");
            }}
          >
            アイテムを編集する
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CreateAlbumSuccess;
